/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founder_Vaisakhan_TitleInputs */

const en_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const de_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgruender & Engineering`)
};

const fr_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const es_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const it_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const nl_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const pl_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const fi_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const da_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const sv_about_founder_vaisakhan_title = /** @type {(inputs: About_Founder_Vaisakhan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

/**
* | output |
* | --- |
* | "Co-Founder & Engineering" |
*
* @param {About_Founder_Vaisakhan_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founder_vaisakhan_title = /** @type {((inputs?: About_Founder_Vaisakhan_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founder_Vaisakhan_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founder_vaisakhan_title(inputs)
	if (locale === "fr") return fr_about_founder_vaisakhan_title(inputs)
	if (locale === "es") return es_about_founder_vaisakhan_title(inputs)
	if (locale === "it") return it_about_founder_vaisakhan_title(inputs)
	if (locale === "nl") return nl_about_founder_vaisakhan_title(inputs)
	if (locale === "pl") return pl_about_founder_vaisakhan_title(inputs)
	if (locale === "fi") return fi_about_founder_vaisakhan_title(inputs)
	if (locale === "da") return da_about_founder_vaisakhan_title(inputs)
	if (locale === "sv") return sv_about_founder_vaisakhan_title(inputs)
	return en_about_founder_vaisakhan_title(inputs)
});